module.exports = __webpack_public_path__ + "img/DasBoot.58253fa4.jpg";